export default payload => ({
    key: new Date().getTime() + Math.floor(Math.random() * 10001),
    ...payload,
});
